(() => {
  const header = document.querySelector('.m-header-shell');
  if (header) {
    let previous = Math.max(0, window.scrollY);
    let direction = 0;
    let distance = 0;
    let scheduled = false;
    const reveal = () => {
      header.classList.remove('is-scroll-hidden');
      header.inert = false;
    };
    const update = () => {
      scheduled = false;
      const y = Math.max(0, Math.min(window.scrollY, document.documentElement.scrollHeight - window.innerHeight));
      const delta = y - previous;
      previous = y;
      const nextDirection = Math.sign(delta);
      if (nextDirection !== direction) distance = 0;
      direction = nextDirection;
      distance += Math.abs(delta);
      if (y < header.offsetHeight || header.contains(document.activeElement) || header.querySelector('details[open]') || document.querySelector('dialog[open]')) {
        reveal();
        distance = 0;
      } else if (distance >= 6) {
        const hidden = direction > 0;
        header.classList.toggle('is-scroll-hidden', hidden);
        header.inert = hidden;
        distance = 0;
      }
    };
    window.addEventListener('scroll', () => {
      if (!scheduled) { scheduled = true; requestAnimationFrame(update); }
    }, { passive: true });
    document.addEventListener('keydown', event => { if (event.key === 'Tab') reveal(); });
    header.addEventListener('focusin', reveal);
  }

  const mobile = window.matchMedia('(max-width: 800px)');
  function initializeFilters() {
    document.querySelectorAll('[data-filter-dialog]').forEach(dialog => {
      if (mobile.matches) return;
      dialog.close();
      const panel = dialog.querySelector('.commerce-filter-panel');
      dialog.replaceWith(panel);
      panel.classList.add('is-open');
      panel.removeAttribute('hidden');
      document.querySelector('[aria-controls="' + panel.id + '"]')?.setAttribute('aria-expanded', 'true');
    });
    if (!mobile.matches) return;
    document.querySelectorAll('.commerce-filter-panel').forEach(panel => {
      if (panel.closest('[data-filter-dialog]')) return;
      const dialog = document.createElement('dialog');
      dialog.className = 'commerce-filter-drawer';
      dialog.dataset.filterDialog = '';
      dialog.setAttribute('aria-label', panel.getAttribute('aria-label') || 'Filters');
      panel.before(dialog);
      dialog.append(panel);
      panel.classList.remove('is-open');
      const trigger = document.querySelector('[aria-controls="' + panel.id + '"]');
      trigger?.setAttribute('aria-expanded', 'false');
      dialog.addEventListener('close', () => {
        panel.classList.remove('is-open');
        trigger?.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('filter-drawer-open');
      });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
    });
  }
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-filter-toggle]');
    if (trigger) {
      const panel = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!panel) return;
      const dialog = panel.closest('[data-filter-dialog]');
      if (dialog) {
        panel.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        document.body.classList.add('filter-drawer-open');
        dialog.showModal();
      } else {
        const open = panel.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', String(open));
      }
    }
    if (event.target.closest('[data-filter-close]')) event.target.closest('[data-filter-dialog]')?.close();
  });
  document.addEventListener('submit', event => {
    if (event.target.matches('.commerce-facets')) event.target.closest('[data-filter-dialog]')?.close();
  }, true);
  document.addEventListener('shopping:section:updated', () => {
    document.body.classList.remove('filter-drawer-open');
    initializeFilters();
  });
  document.addEventListener('shopify:section:load', initializeFilters);
  mobile.addEventListener('change', initializeFilters);
  initializeFilters();
})();
